import React, { useState, useEffect } from 'react';
//import { sendPasswordResetEmail } from 'firebase/auth';
import { useParams, useSearchParams, useNavigate, useLocation } from 'react-router-dom';
//import { auth } from '../../firebase/config';
import styles from './ForgotPassword.module.css';
import logo from './../../assets/logo.png';
import { FaEnvelope } from 'react-icons/fa';
import CompactNavbar from './../CompactNavbar/CompactNavbar';
import { motion } from 'framer-motion';
import { useAuth } from "../../utils/AuthContext/authcontext";
import Button from '../ui/Button';

const ForgotPassword = ({modal, onLoginForm, setpassword }) => {
  const [email, setEmail] = useState('');
  const [passwordChange, setPasswordChange] = useState(false);
  const [password, setPassword] = useState('');
  const location = useLocation();
  const { passwordReset, verifyPasswordReset, confirmPasswordResetNow } = useAuth();
  const query = new URLSearchParams(location.search);
  const oobCode = query.get('oobCode');
  const oobCodeMode = query.get('mode');
  const navigate = useNavigate();


  useEffect(() => {
    if (setpassword != true || oobCodeMode != "resetPassword") {
      return;
    }

    async function fetchData() {
      try {
        const emailaddress = await verifyPasswordReset(oobCode);
        console.log(setpassword, oobCode, oobCodeMode, emailaddress);
        if(emailaddress?.length <= 0) navigate('/login');
        setPasswordChange(true);
      } catch (err) {
         navigate('/login');
      }
  }

  fetchData();

  }, [setpassword]);

  const handleReset = async e => {
    e.preventDefault();
    try {
      if(email.length > 3) {
        await passwordReset(email);
        console.log('Password reset email sent!');
      }
      if(password.length > 3) {
        await confirmPasswordResetNow(oobCode, password);
        console.log('Password changed!');
      }
      navigate('/login');
    } catch (err) {
      alert('Failed to send reset email. Please try again.');
      console.error(err.message);
    }
  };

  return (
    <div className={` ${modal == undefined ? styles.container : styles.containermodal }`}>
      {/* Navbar */}
      {/*<nav className={` ${modal == undefined ? styles.navbar : styles.navbarmodal }`}>
        <div className={styles.logoContainer}>
          <img src={logo} alt="Logo" className={styles.logo} />
          <span className={styles.appName}>Ratio</span>
        </div>
      </nav>*/}

      <nav className={` ${modal == undefined ? styles.navbardiv : styles.navbarmodal }`}>
        <CompactNavbar  modal={false} scrollY={0} openContact={null} openLogin={null}/>
      </nav>

      {/* Reset Card */}
		<motion.div
			className={styles.stepContainer}
			initial={{ opacity: 0, scale: 0.9 }}
			animate={{ opacity: 1, scale: 1 }}
			transition={{
			duration: 0.4,
			scale: { type: "spring", visualDuration: 0.4, bounce: 0.5 },}}>
      <div className={styles.card}>
        <h2 className={styles.title}>Reset Password</h2>
        <p className={styles.subtitle}>Enter your email and we will send you a link to reset it.</p>

        <form onSubmit={handleReset} className={styles.form}>
          <div className={styles.inputGroup}>
            <FaEnvelope className={styles.icon} />
            {passwordChange == false ? <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              className={styles.input}/> :  <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              className={styles.input} /> }
          </div>

          <Button type="submit" variant="primary" className={styles.loginButton}>
            {passwordChange == false ? "Send Reset Link" : "Update Password"}
          </Button>
        </form>

        <div className={styles.separator}>
          <span className={styles.separatorText}>or</span>
        </div>

        <div className={styles.footer}>
          <Button variant="ghost" className={styles.linkButton} onClick={() => {onLoginForm != null ? onLoginForm() : navigate('/login')}}>
            Back to Login
          </Button>
          <Button variant="ghost" className={styles.linkButton} onClick={() => navigate('/register')}>
            Create an Account
          </Button>
        </div>
      </div>
	  </motion.div>
    </div>
  );
};

export default ForgotPassword;
